export default __webpack_public_path__ + "7229313d1871a9e995f1f0d04e2c70ee.png";